import { render, staticRenderFns } from "./event-level.vue?vue&type=template&id=b489891e&scoped=true"
import script from "./event-level.vue?vue&type=script&lang=js"
export * from "./event-level.vue?vue&type=script&lang=js"
import style0 from "./event-level.vue?vue&type=style&index=0&id=b489891e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b489891e",
  null
  
)

export default component.exports